import { useTheme } from "../ThemeContext";
import { useState, useEffect, useCallback } from "react";

const SUPORTADAS = [
  { codigo: "PYG", nome: "Guaraní", simbolo: "₲", bandeira: "🇵🇾" },
  { codigo: "USD", nome: "Dólar",   simbolo: "$", bandeira: "🇺🇸" },
];

const FORMATOS = [
  { v: "so_brl",    l: "Só Real",                d: "Mostra apenas R$ (padrão atual)" },
  { v: "lado_lado", l: "Lado a lado",            d: "Mostra R$ + moeda secundária. Ex: \"R$ 25,00 · ₲ 36.250\"" },
  { v: "detectar",  l: "Detectar por GPS",       d: "Cliente no Brasil vê R$. No Paraguai vê ₲. Pode trocar no seletor" },
  { v: "escolher",  l: "Cliente escolhe",        d: "Mostra seletor de moeda no topo. Cliente escolhe BRL/PYG/USD" },
];

export default function Moedas({ lojaId }) {
  const { theme: C } = useTheme();
  const [config, setConfig] = useState({
    catalogo: {
      formato: "so_brl",
      moedas_ativas: { PYG: false, USD: false },
      moeda_padrao: "BRL",
      mostrar_taxa: true,
    },
    app: {
      formato: "so_brl",
      moedas_ativas: { PYG: false, USD: false },
      moeda_padrao: "BRL",
      mostrar_taxa: true,
    }
  });
  const [taxas, setTaxas] = useState({ pyg: 1.71, usd: 5.68 });
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [toast, setToast] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState("catalogo"); // catalogo | app

  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2800); };

  // Carrega config + taxas do servidor
  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      // Câmbio
      const rt = await fetch(`https://mixupbr.com.br/api/loja_config/?loja_id=${lojaId || 1}&acao=get_cambio`);
      const dt = await rt.json();
      if (dt && dt.taxas) {
        setTaxas({
          pyg: parseFloat(String(dt.taxas.pyg || "1.71").replace(",", ".")),
          usd: parseFloat(String(dt.taxas.usd || "5.68").replace(",", ".")),
        });
      }
      // Config de exibição
      const rc = await fetch(`https://mixupbr.com.br/api/loja_config/?loja_id=${lojaId || 1}&acao=get_moedas_config`);
      const dc = await rc.json();
      if (dc && dc.ok && dc.config) {
        // Merge com defaults pra garantir estrutura
        setConfig(prev => ({
          catalogo: { ...prev.catalogo, ...(dc.config.catalogo || {}) },
          app:      { ...prev.app,      ...(dc.config.app || {}) },
        }));
      }
    } catch (e) {}
    setCarregando(false);
  }, [lojaId]);

  useEffect(() => { carregar(); }, [carregar]);

  const salvar = async () => {
    setSalvando(true);
    try {
      const r = await fetch("https://mixupbr.com.br/api/loja_config/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ loja_id: lojaId || 1, acao: "salvar_moedas_config", config })
      });
      const d = await r.json();
      if (d && (d.ok || d.sucesso)) {
        notify("✓ Configurações salvas");
      } else {
        notify("Erro: " + (d.erro || "desconhecido"), false);
      }
    } catch (e) { notify("Erro de conexão", false); }
    setSalvando(false);
  };

  const setCfg = (canal, campo, valor) => {
    setConfig(prev => ({
      ...prev,
      [canal]: { ...prev[canal], [campo]: valor }
    }));
  };

  const toggleMoeda = (canal, codigo) => {
    setConfig(prev => ({
      ...prev,
      [canal]: {
        ...prev[canal],
        moedas_ativas: {
          ...prev[canal].moedas_ativas,
          [codigo]: !prev[canal].moedas_ativas[codigo]
        }
      }
    }));
  };

  // Preview: como vai aparecer o preço pro cliente
  const previewPreco = (canal) => {
    const cfg = config[canal];
    const exemploBRL = 25.00;
    if (cfg.formato === "so_brl") return "R$ 25,00";
    if (cfg.formato === "lado_lado") {
      const partes = ["R$ 25,00"];
      if (cfg.moedas_ativas.PYG) partes.push("₲ " + Math.round(exemploBRL * taxas.pyg * 1000 / taxas.pyg * taxas.pyg).toLocaleString("pt-BR"));
      if (cfg.moedas_ativas.USD) partes.push("$ " + (exemploBRL / taxas.usd).toFixed(2).replace(".", ","));
      return partes.join(" · ");
    }
    if (cfg.formato === "detectar") return "🌎 Detectado pelo GPS (R$ no Brasil, ₲ no Paraguai)";
    if (cfg.formato === "escolher") return "🎚️ Cliente escolhe (seletor no topo)";
    return "R$ 25,00";
  };

  // Estilos
  const sCard = { background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: 20, marginBottom: 16 };
  const sChip = (ativo, cor = "#3B82F6") => ({
    padding: "10px 14px",
    borderRadius: 10,
    border: `2px solid ${ativo ? cor : C.border}`,
    background: ativo ? cor + "15" : "transparent",
    color: ativo ? cor : C.text,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    flex: 1,
    textAlign: "center",
    transition: "all .15s"
  });
  const sLabel = { fontSize: 11, color: C.textMuted, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8, display: "block" };

  if (carregando) {
    return <div style={{ maxWidth: 800, margin: "0 auto", padding: 40, textAlign: "center", color: C.textMuted }}>Carregando configurações...</div>;
  }

  const cfg = config[abaAtiva];

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", animation: "fadeUp .4s ease-out", paddingBottom: 80 }}>
      {toast && (
        <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", zIndex: 9999, background: toast.ok ? "#22C55E" : "#EF4444", color: "#fff", padding: "10px 24px", borderRadius: 10, fontWeight: 700, fontSize: 13 }}>{toast.msg}</div>
      )}

      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
        <div style={{ width: 52, height: 52, borderRadius: 16, background: "#3B82F618", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>🌎</div>
        <div>
          <h1 style={{ fontFamily: "'Plus Jakarta Sans'", fontWeight: 800, fontSize: 26, marginBottom: 2 }}>Exibição de Moedas</h1>
          <p style={{ fontSize: 13, color: C.textMuted }}>Configure como o preço aparece pro cliente. O R$ é sempre a base, demais moedas convertem pelo câmbio do dia.</p>
        </div>
      </div>

      {/* Aviso de taxas atuais */}
      <div style={{ ...sCard, background: `${C.orange}10`, borderColor: `${C.orange}40`, display: "flex", alignItems: "center", gap: 14 }}>
        <div style={{ fontSize: 24 }}>💱</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: C.textMuted, fontWeight: 700 }}>Câmbio atual</div>
          <div style={{ fontSize: 14, fontWeight: 700, marginTop: 2 }}>
            R$ 1,00 = ₲ {taxas.pyg.toFixed(2).replace(".", ",")} &nbsp;·&nbsp; US$ 1,00 = R$ {taxas.usd.toFixed(2).replace(".", ",")}
          </div>
          <div style={{ fontSize: 11, color: C.textMuted, marginTop: 4 }}>Atualize as taxas em <b>Câmbio</b> antes de abrir o caixa.</div>
        </div>
      </div>

      {/* Tabs canal */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
        <div onClick={() => setAbaAtiva("catalogo")} style={{
          ...sChip(abaAtiva === "catalogo", "#3B82F6"),
          padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "center", gap: 8
        }}>
          🌐 Catálogo Web
        </div>
        <div onClick={() => setAbaAtiva("app")} style={{
          ...sChip(abaAtiva === "app", "#22C55E"),
          padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "center", gap: 8
        }}>
          📱 App Rapiditos
        </div>
      </div>

      {/* Configuração do canal selecionado */}
      <div style={sCard}>
        {/* Formato */}
        <label style={sLabel}>Como exibir o preço?</label>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 20 }}>
          {FORMATOS.map(f => (
            <div key={f.v} onClick={() => setCfg(abaAtiva, "formato", f.v)} style={{
              padding: "12px 14px",
              borderRadius: 10,
              border: `2px solid ${cfg.formato === f.v ? "#3B82F6" : C.border}`,
              background: cfg.formato === f.v ? "#3B82F615" : "transparent",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 12,
              transition: "all .15s"
            }}>
              <div style={{
                width: 18, height: 18, borderRadius: "50%",
                border: `2px solid ${cfg.formato === f.v ? "#3B82F6" : C.border}`,
                display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                {cfg.formato === f.v && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#3B82F6" }} />}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{f.l}</div>
                <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>{f.d}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Moedas ativas — só aparece se formato precisar */}
        {(cfg.formato === "lado_lado" || cfg.formato === "detectar" || cfg.formato === "escolher") && (
          <>
            <label style={sLabel}>Quais moedas exibir além do Real?</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
              {SUPORTADAS.map(m => {
                const ativo = cfg.moedas_ativas[m.codigo];
                return (
                  <div key={m.codigo} onClick={() => toggleMoeda(abaAtiva, m.codigo)} style={{
                    ...sChip(ativo, "#3B82F6"),
                    padding: "14px 12px",
                    display: "flex", flexDirection: "column", alignItems: "center", gap: 4
                  }}>
                    <div style={{ fontSize: 26 }}>{m.bandeira}</div>
                    <div style={{ fontSize: 13, fontWeight: 800 }}>{m.codigo}</div>
                    <div style={{ fontSize: 10, opacity: 0.7 }}>{m.nome}</div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* Moeda padrão — só quando "escolher" */}
        {cfg.formato === "escolher" && (
          <>
            <label style={sLabel}>Moeda inicial mostrada (antes do cliente escolher)</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
              <div onClick={() => setCfg(abaAtiva, "moeda_padrao", "BRL")} style={sChip(cfg.moeda_padrao === "BRL", "#22C55E")}>🇧🇷 BRL</div>
              {SUPORTADAS.map(m => cfg.moedas_ativas[m.codigo] && (
                <div key={m.codigo} onClick={() => setCfg(abaAtiva, "moeda_padrao", m.codigo)} style={sChip(cfg.moeda_padrao === m.codigo, "#22C55E")}>
                  {m.bandeira} {m.codigo}
                </div>
              ))}
            </div>
          </>
        )}

        {/* Moeda padrão para detectar (fallback) */}
        {cfg.formato === "detectar" && (
          <>
            <label style={sLabel}>Moeda padrão quando GPS não detecta (ex: VPN, outro país)</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
              <div onClick={() => setCfg(abaAtiva, "moeda_padrao", "BRL")} style={sChip(cfg.moeda_padrao === "BRL", "#22C55E")}>🇧🇷 BRL</div>
              {SUPORTADAS.map(m => cfg.moedas_ativas[m.codigo] && (
                <div key={m.codigo} onClick={() => setCfg(abaAtiva, "moeda_padrao", m.codigo)} style={sChip(cfg.moeda_padrao === m.codigo, "#22C55E")}>
                  {m.bandeira} {m.codigo}
                </div>
              ))}
            </div>
          </>
        )}

        {/* Mostrar taxa */}
        {cfg.formato !== "so_brl" && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 14px", background: C.bg, borderRadius: 10, border: `1px solid ${C.border}` }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700 }}>Mostrar taxa de câmbio no topo</div>
              <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>Banner com "Hoje: 1 BRL = ₲ {taxas.pyg.toFixed(2).replace(".", ",")}"</div>
            </div>
            <div onClick={() => setCfg(abaAtiva, "mostrar_taxa", !cfg.mostrar_taxa)} style={{
              width: 46, height: 26, borderRadius: 13,
              background: cfg.mostrar_taxa ? "#22C55E" : C.border,
              position: "relative", cursor: "pointer",
              transition: "all .2s"
            }}>
              <div style={{
                width: 20, height: 20, borderRadius: "50%",
                background: "#fff", position: "absolute",
                top: 3, left: cfg.mostrar_taxa ? 23 : 3,
                transition: "all .2s",
                boxShadow: "0 2px 4px rgba(0,0,0,.2)"
              }} />
            </div>
          </div>
        )}
      </div>

      {/* Preview */}
      <div style={{ ...sCard, background: `${C.green}10`, borderColor: `${C.green}40` }}>
        <label style={sLabel}>📱 Como vai aparecer no {abaAtiva === "catalogo" ? "Catálogo Web" : "App Rapiditos"}</label>
        <div style={{ padding: 16, background: C.card, borderRadius: 10, border: `1px solid ${C.border}`, textAlign: "center" }}>
          <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 6 }}>X-Bacon Duplo</div>
          <div style={{ fontSize: 18, fontWeight: 800, color: "#22C55E", fontFamily: "monospace" }}>
            {previewPreco(abaAtiva)}
          </div>
        </div>
      </div>

      {/* Botão salvar */}
      <button onClick={salvar} disabled={salvando} style={{
        width: "100%",
        padding: 16,
        borderRadius: 12,
        border: "none",
        background: salvando ? C.textMuted : "#E8201A",
        color: "#fff",
        fontSize: 16,
        fontWeight: 800,
        cursor: salvando ? "not-allowed" : "pointer",
        transition: "all .2s",
        marginTop: 8
      }}>
        {salvando ? "Salvando..." : "💾 Salvar configurações"}
      </button>

      <div style={{ marginTop: 16, padding: 14, borderRadius: 10, background: `${C.orange}10`, border: `1px solid ${C.orange}30` }}>
        <div style={{ fontSize: 12, color: C.orange, fontWeight: 700, lineHeight: 1.6 }}>
          💡 <b>Dica:</b> as conversões usam o câmbio do dia. Quando você atualizar as taxas em <b>Câmbio</b>, todos os preços recalculam automaticamente sem precisar mexer em produto algum.
        </div>
      </div>
    </div>
  );
}
